export default __webpack_public_path__ + "static/media/iphone_instructions.0fc82828.png";